/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentFragmentDoc } from './ShipmentFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentsQueryVariables = Types.Exact<{
  after?: Types.Maybe<Types.Scalars['String']>
  before?: Types.Maybe<Types.Scalars['String']>
  customerId?: Types.Maybe<Types.Scalars['String']>
  dispatcherId?: Types.Maybe<Types.Scalars['Int']>
  driverId?: Types.Maybe<Types.Scalars['Int']>
  dropoffDate?: Types.Maybe<Types.Scalars['String']>
  dropoffFacilityId?: Types.Maybe<Types.Scalars['Int']>
  dropoffLocality?: Types.Maybe<Types.Scalars['String']>
  dropoffSubdivisionCode?: Types.Maybe<Types.Scalars['String']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
  maxAge?: Types.Maybe<Types.Scalars['Int']>
  motorCarrierId?: Types.Maybe<Types.Scalars['Int']>
  pickupDate?: Types.Maybe<Types.Scalars['String']>
  pickupFacilityId?: Types.Maybe<Types.Scalars['Int']>
  pickupLocality?: Types.Maybe<Types.Scalars['String']>
  pickupSubdivisionCode?: Types.Maybe<Types.Scalars['String']>
  referenceNumber?: Types.Maybe<Types.Scalars['String']>
  status?: Types.Maybe<Array<Types.IShipmentStatus> | Types.IShipmentStatus>
  onlyExternalLoad?: Types.Maybe<Types.Scalars['String']>
  groupedStatus: Array<Types.IStatusCountInput> | Types.IStatusCountInput
}>

export type IShipmentsQuery = { __typename?: 'Query' } & {
  shipments: { __typename?: 'ShipmentConnection' } & Pick<
    Types.IShipmentConnection,
    'totalCount' | 'trackingStatusCount' | 'groupedStatusCount'
  > & {
      nodes?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'Shipment' } & Pick<
              Types.IShipment,
              | 'id'
              | 'currentStopSequence'
              | 'firstPickupStartAt'
              | 'isExternal'
              | 'marketplaceId'
              | 'missingInfo'
              | 'missingInfoUrgencyMessage'
              | 'motorCarrierId'
              | 'mpPodState'
              | 'podUploaded'
              | 'status'
              | 'trailerType'
              | 'vin'
            > & {
                customer?: Types.Maybe<
                  { __typename?: 'Customer' } & Pick<Types.ICustomer, 'id' | 'name'>
                >
                drivers?: Types.Maybe<
                  Array<
                    { __typename?: 'Driver' } & Pick<
                      Types.IDriver,
                      | 'id'
                      | 'createdAt'
                      | 'firstName'
                      | 'lastName'
                      | 'motorCarrierId'
                      | 'name'
                      | 'transfixUserId'
                    >
                  >
                >
                etaObject?: Types.Maybe<
                  { __typename?: 'EtaObject' } & Pick<
                    Types.IEtaObject,
                    'eta' | 'drivingDistance' | 'onTime'
                  >
                >
                motorCarrier: { __typename?: 'MotorCarrier' } & Pick<
                  Types.IMotorCarrier,
                  'id' | 'name' | 'mcNumber' | 'dotNumber' | 'legalName'
                >
                stops: Array<
                  { __typename?: 'Stops' } & Pick<
                    Types.IStops,
                    | 'relativeStopSequence'
                    | 'city'
                    | 'countryCode'
                    | 'displayTimezone'
                    | 'endAt'
                    | 'id'
                    | 'marketplaceId'
                    | 'shipmentId'
                    | 'startAt'
                    | 'stateCode'
                    | 'stopSequence'
                    | 'stopType'
                  > & {
                      address: { __typename?: 'Address' } & Pick<
                        Types.IAddress,
                        | 'addressLine1'
                        | 'addressLine2'
                        | 'addressee'
                        | 'countryCode'
                        | 'displayTimezone'
                        | 'locality'
                        | 'postalCode'
                        | 'subdivisionCode'
                      >
                    }
                >
                trackingSummary?: Types.Maybe<
                  { __typename?: 'ShipmentTrackingSummary' } & Pick<
                    Types.IShipmentTrackingSummary,
                    'isTracking' | 'shouldBeTracking'
                  >
                >
                trailer?: Types.Maybe<
                  { __typename?: 'Trailer' } & Pick<Types.ITrailer, 'id' | 'number' | 'trailerType'>
                >
                truck?: Types.Maybe<
                  { __typename?: 'Truck' } & Pick<Types.ITruck, 'id' | 'entityId' | 'truckNumber'>
                >
              }
          >
        >
      >
      pageInfo: { __typename?: 'PageInfo' } & Pick<
        Types.IPageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >
    }
}

export const ShipmentsDocument = gql`
  query Shipments(
    $after: String
    $before: String
    $customerId: String
    $dispatcherId: Int
    $driverId: Int
    $dropoffDate: String
    $dropoffFacilityId: Int
    $dropoffLocality: String
    $dropoffSubdivisionCode: String
    $first: Int
    $last: Int
    $maxAge: Int
    $motorCarrierId: Int
    $pickupDate: String
    $pickupFacilityId: Int
    $pickupLocality: String
    $pickupSubdivisionCode: String
    $referenceNumber: String
    $status: [ShipmentStatus!]
    $onlyExternalLoad: String
    $groupedStatus: [StatusCountInput!]!
  ) {
    shipments(
      after: $after
      before: $before
      customerId: $customerId
      dispatcherId: $dispatcherId
      driverId: $driverId
      dropoffDate: $dropoffDate
      dropoffFacilityId: $dropoffFacilityId
      dropoffLocality: $dropoffLocality
      dropoffSubdivisionCode: $dropoffSubdivisionCode
      first: $first
      last: $last
      maxAge: $maxAge
      motorCarrierId: $motorCarrierId
      pickupDate: $pickupDate
      pickupFacilityId: $pickupFacilityId
      pickupLocality: $pickupLocality
      pickupSubdivisionCode: $pickupSubdivisionCode
      referenceNumber: $referenceNumber
      status: $status
      onlyExternalLoad: $onlyExternalLoad
    ) {
      nodes {
        ...Shipment
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      trackingStatusCount
      groupedStatusCount(
        groupedStatus: $groupedStatus
        customerId: $customerId
        dispatcherId: $dispatcherId
        driverId: $driverId
        dropoffDate: $dropoffDate
        dropoffFacilityId: $dropoffFacilityId
        dropoffLocality: $dropoffLocality
        dropoffSubdivisionCode: $dropoffSubdivisionCode
        maxAge: $maxAge
        motorCarrierId: $motorCarrierId
        pickupDate: $pickupDate
        pickupFacilityId: $pickupFacilityId
        pickupLocality: $pickupLocality
        pickupSubdivisionCode: $pickupSubdivisionCode
        referenceNumber: $referenceNumber
        status: $status
        onlyExternalLoad: $onlyExternalLoad
      )
    }
  }
  ${ShipmentFragmentDoc}
`

/**
 * __useShipmentsQuery__
 *
 * To run a query within a React component, call `useShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      customerId: // value for 'customerId'
 *      dispatcherId: // value for 'dispatcherId'
 *      driverId: // value for 'driverId'
 *      dropoffDate: // value for 'dropoffDate'
 *      dropoffFacilityId: // value for 'dropoffFacilityId'
 *      dropoffLocality: // value for 'dropoffLocality'
 *      dropoffSubdivisionCode: // value for 'dropoffSubdivisionCode'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      maxAge: // value for 'maxAge'
 *      motorCarrierId: // value for 'motorCarrierId'
 *      pickupDate: // value for 'pickupDate'
 *      pickupFacilityId: // value for 'pickupFacilityId'
 *      pickupLocality: // value for 'pickupLocality'
 *      pickupSubdivisionCode: // value for 'pickupSubdivisionCode'
 *      referenceNumber: // value for 'referenceNumber'
 *      status: // value for 'status'
 *      onlyExternalLoad: // value for 'onlyExternalLoad'
 *      groupedStatus: // value for 'groupedStatus'
 *   },
 * });
 */
export function useShipmentsQuery(
  baseOptions: Apollo.QueryHookOptions<IShipmentsQuery, IShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipmentsQuery, IShipmentsQueryVariables>(ShipmentsDocument, options)
}
export function useShipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IShipmentsQuery, IShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipmentsQuery, IShipmentsQueryVariables>(ShipmentsDocument, options)
}
export type ShipmentsQueryHookResult = ReturnType<typeof useShipmentsQuery>
export type ShipmentsLazyQueryHookResult = ReturnType<typeof useShipmentsLazyQuery>
export type ShipmentsQueryResult = Apollo.QueryResult<IShipmentsQuery, IShipmentsQueryVariables>
